/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClickStartUploadEndpointRequest
 */
export interface ClickStartUploadEndpointRequest {
    /**
     * 
     * @type {number}
     * @memberof ClickStartUploadEndpointRequest
     */
    connection: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClickStartUploadEndpointRequest
     */
    assets: Array<number>;
}

export function ClickStartUploadEndpointRequestFromJSON(json: any): ClickStartUploadEndpointRequest {
    return ClickStartUploadEndpointRequestFromJSONTyped(json, false);
}

export function ClickStartUploadEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClickStartUploadEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'connection': json['connection'],
        'assets': json['assets'],
    };
}

export function ClickStartUploadEndpointRequestToJSON(value?: ClickStartUploadEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'connection': value.connection,
        'assets': value.assets,
    };
}


